// plugins/vueperslides.client.js
import { VueperSlide, VueperSlides } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VueperSlides', VueperSlides);
  nuxtApp.vueApp.component('VueperSlide', VueperSlide);
});
